<template>
  <div class="right-box">
    <title1 type="1" title="最新告警列表信息" />
    <div class="box-1" style="height: 360px">
      <dv-scroll-board :config="config" class="newTable" />
    </div>
  </div>
</template>

<script>
import title1 from "@/views/exposition/components/title1";
import { formatTime } from "@/utils/index";
import { dataInterface } from "@/api/dataInterfaceApi";
export default {
  components: {
    title1,
  },
  data() {
    let { stationId } = this.$route.query;
    return {
      stationId: stationId,
      config: {
        headerBGC: "rgba(53, 149, 147, 0.2)",
        headerHeight: 50,
        carousel: "single",

        hoverPause: true,
        oddRowBGC: "rgba(53, 149, 147, 0)",
        evenRowBGC: "rgba(53, 149, 147, 0)",
        rowNum: 3, //表格行数
        header: [
          "设备类型",
          "告警等级",
          "告警内容",
          "告警开始时间",
          "告警结束时间",
          "状态",
        ],
        data: [],
      },
      videoObj: {},
      videoList: [],
    };
  },
  methods: {
    // 告警列表
    gaojingliebiao() {
      let _this = this;
      let params = {
        enCode: "chuneng-quanguo-gjlb",
      };
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if (!res || !res.length) return;
          let newList = [];
          res.map((item) => {
            newList.push([
              item.device_type,
              item.alarm_level,
              item.alarm_content,
              item.start_time,
              item.end_time,
              item.status,
            ]);
          });
          // console.log(newList, "newList");
          this.config = {
            headerBGC: "rgba(53, 149, 147, 0.2)",
            headerHeight: 50,
            carousel: "single",
            hoverPause: true,
            oddRowBGC: "rgba(53, 149, 147, 0.2)",
            evenRowBGC: "rgba(53, 149, 147, 0)",
            rowNum: 5, //表格行数
            header: [
              "设备类型",
              "告警等级",
              "告警内容",
              "告警开始时间",
              "告警结束时间",
              "状态",
            ],
            data: newList,
          };
        })
        .catch((err) => {
          console.log(err, "error");
        });
    },
  },
  mounted() {
    // this.$bus.$on("onfangdiangonglv", () => {
    //   this.gaojingliebiao();
    // });
    this.gaojingliebiao();
  },
};
</script>

<style lang="scss" scoped>
@import "@/views/components/energyStorage/comm.scss";
.video-box-new {
  height: 610px;
  .video-item-new {
    width: 50%;
    height: 250px;
    padding: 10px;
    margin-bottom: 100px;
    box-sizing: border-box;
    .video {
      width: 100%;
      height: 100%;
    }
  }
}
.dv-scroll-board ::v-deep .header {
  font-size: $FontSize24;
}
.dv-scroll-board ::v-deep .rows .row-item {
  font-size: $FontSize18;
}

.newTable {
  line-height: 90px;
  font-size: 24px !important;
  padding-right: 34px;

  &.dv-scroll-board {
    .header,
    .rows .row-item {
      height: 90px !important;
      font-size: 24px !important;
    }
    .header {
      font-size: 24px !important;
    }
  }
}
</style>